import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import jobsReducer from './reducers';

const importFlatBuilds = () => import(/* webpackChunkName: "jobs-open-flat-builds" */ './containers/OpenSauceFlatBuildsContainer');
const importFlatJobs = () => import(/* webpackChunkName: "jobs-open-flat-jobs" */ './containers/OpenSauceFlatJobsContainer');

const JobsOpenSauceRoutes = ({ match }) => (
  <Switch>
    <Redirect
      from={`${match.url}/user/:username/tests/:cloudType`}
      push
      to={`${match.url}/user/:username/tests`}
    />
    <BundleRoute
      exact
      load={importFlatBuilds}
      path={`${match.url}/user/:username/builds/:cloudType(rdc|vdc)`}
    />
    <BundleRoute
      load={importFlatBuilds}
      path={`${match.url}/user/:username/builds`}
    />
    <BundleRoute
      load={importFlatJobs}
      path={`${match.url}/user/:username/tests`}
    />
    <Redirect
      from={`${match.url}/user/:username`}
      to={`${match.url}/user/:username/tests`}
    />
    <Redirect
      from={`${match.url}/u/:username`}
      to={`${match.url}/user/:username`}
    />
  </Switch>
);

JobsOpenSauceRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default dynamic(
  'apps.jobs', attachReducer(jobsReducer),
)(JobsOpenSauceRoutes);
export { JobsOpenSauceRoutes };
